export enum SalesChannel {
  Ecommerce = 'ECOMMERCE',
  Mail = 'MAIL',
  Phone = 'PHONE',
  Pos = 'POS',
  Moto = 'MOTO',
}
